//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QINIU_SERVER } from '../../../config'
import addressIcon from 'assets/icons/icon-address@3x.png'
import timeIcon from 'assets/icons/icon-time@3x.png'
import { mapActions } from 'vuex'

export default {
  name: 'CustomCard',
  components: {

  },
  props: ['route', 'kind'],
  data() {
    return {
      addressIcon,
      timeIcon,
      checkTalentRaiders: false,
    }
  },
  computed: {
    qiniuImage() {
      return `${QINIU_SERVER}${this.route.image}-m.cover.thumb.jpg`
    },
    details() {
      if (this.kind === 0) {
        return {
          first: '观赛攻略',
          second: '参考线路',
        }
      }
      return {
        first: '出游攻略',
        second: '达人分享',
      }
    },
    links() {
      if (this.kind === 0) {
        const params = { params: this.route.strategyId ?
          { articleId: this.route.strategyId, img: this.qiniuImage } : null }
        return {
          title: Object.assign({ name: 'match-raiders' }, params),
          image: Object.assign({ name: 'match-raiders' }, params),
          first: Object.assign({ name: 'match-raiders' }, params),
          second: Object.assign({ name: 'refer-route' },
            { params: this.route.referenceLineId ?
              { articleId: this.route.referenceLineId, img: this.qiniuImage } : null }),
        }
      }
      const params = { params: this.route.cityIntroductionId ?
        { articleId: this.route.cityIntroductionId, img: this.qiniuImage } : null }

      this.checkTalentRaiders = this.route.topicCount > 0

      return {
        title: { name: 'talent-raiders', params: { sportsRouteId: this.route.id, img: this.qiniuImage } },
        image: { name: 'talent-raiders', params: { sportsRouteId: this.route.id, img: this.qiniuImage } },
        first: Object.assign({ name: 'city-intro' }, params),
        second: { name: 'talent-raiders', params: { sportsRouteId: this.route.id, img: this.qiniuImage } },
      }
    },
    styleSports() {
      if (this.kind === 0) {
        return {
          p: {},
          div: {},
        }
      }
      return {
        p: { 'margin-top': '15px' },
        div: { 'margin-top': '9px' },
      }
    },
  },
  methods: {
    ...mapActions(['showToast']),
    routeTo(route) {
      if (route.params) {
        if (route.name !== 'talent-raiders' || (route.name === 'talent-raiders' && this.checkTalentRaiders)) {
          this.$router.push(route)
        }
      }
    },
    checkLink(type) {
      if (this.links) {
        if (this.kind !== 0 && type === 'second') {
          return this.checkTalentRaiders
        }
        return this.links[type] && this.links[type].params
      }
      return true
    },
  },
}



// WEBPACK FOOTER //
// ./client/components/Common/Card/CustomCard.vue